module.exports = __webpack_public_path__ + "media/file_example_MP3_1MG.ae912083.mp3";